import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Itinerary } from '../../ts/interfaces/OphirResponse';

interface OphirItineraty2Props {
  itinerary: Itinerary;
}

const cleanDayHeader = (itemDesc: string, day: number): string => {
  const location = itemDesc?.replace(/^ДЕНЬ \d+[:.\s–-]*\s*/, '').trimStart();
  return location ? `ДЕНЬ ${day}. ${location}` : `ДЕНЬ ${day}`;
};

const itineraryV2Styles = `
  .ophir-itinerary-v2 {
    page-break-before: always;
    break-before: page;
    margin: 0 auto;
    padding: 0 0 40px;
    line-height: 1.6;
    color: var(--color-500, #333);
  }
  .ophir-itinerary-v2 .ophir-day-section {
    margin-bottom: 45px;
  }
  .ophir-itinerary-v2 .ophir-day-header {
    background: var(--color-contrast, #003654);
    color: #fff;
    padding: 15px 25px;
    font-size: 20px;
    font-weight: bold;
    margin-bottom: 20px;
    border-radius: 8px;
    page-break-after: avoid;
    break-after: avoid;
  }
  .ophir-itinerary-v2 .ophir-day-content {
    display: flex;
    flex-direction: row;
    gap: 25px;
    align-items: flex-start;
    page-break-before: avoid;
    break-before: avoid;
  }
  .ophir-itinerary-v2 .ophir-day-text {
    flex: 1;
    text-align: justify;
    font-size: 14px;
    line-height: 1.8;
    color: var(--color-400, #666);
  }
  .ophir-itinerary-v2 .ophir-day-text .ophir-optional-tag {
    display: inline-block;
    background: #ff9800;
    color: #fff;
    padding: 4px 12px;
    border-radius: 4px;
    font-size: 12px;
    margin-bottom: 10px;
    font-weight: bold;
  }
  .ophir-itinerary-v2 .ophir-day-text .ophir-itinerary-desc {
    margin-top: 10px;
  }
  .ophir-itinerary-v2 .ophir-day-text .ophir-itinerary-desc:first-of-type {
    padding-top: 10px;
    border-top: 1px solid var(--color-text-light, #a49f9f);
  }
  .ophir-itinerary-v2 .ophir-day-image {
    width: 30%;
    flex-shrink: 0;
    max-width: 150px;
  }
  .ophir-itinerary-v2 .ophir-day-image img {
    width: 100%;
    height: auto;
    border-radius: 8px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  }

  body {
  padding: 20px;
  }
`;

const OphirItineraty2: FC<OphirItineraty2Props> = ({ itinerary }) => {
  const [t] = useTranslation() as unknown as [(key: string) => string];

  if (!itinerary.items?.length) {
    return null;
  }

  return (
    <>
      <style>{itineraryV2Styles}</style>
      <div className="ophir-itinerary-v2">
        {itinerary.items.map((item, index) => {
          const hasAddons =
            item.details?.addons?.filter((addon) => addon.DescLang?.length)?.length > 0;

          return (
            <div className="ophir-day-section" key={item.itemId ?? index}>
              <div className="ophir-day-header">
                {cleanDayHeader(item.itemDesc, item.details.day)}
              </div>
              <div className="ophir-day-content">
                <div className="ophir-day-text">
                  {hasAddons && (
                    <span className="ophir-optional-tag">
                      {t('itinerary.optional_extra') || 'За дополнительную плату'}
                    </span>
                  )}
                  {item.details.description}
                  {item.details?.addons
                    ?.filter((addon) => addon.DescLang?.length)
                    ?.map((addon, addonIndex) => (
                      <div className="ophir-itinerary-desc" key={addonIndex}>
                        <span className="text-bold">{addon.DescLang[0].Desc}</span>
                        <br />
                        {addon.DescLang[0].ProductDesc}
                        {addon.Tags && (
                          <>
                            <br />
                            {addon.Tags}
                          </>
                        )}
                      </div>
                    ))}
                </div>
                <div className="ophir-day-image">
                  <img
                    src={item.details.image?.link}
                    alt={item.details.image?.alt ?? ''}
                    style={{ maxWidth: '150px', width: '100%', height: 'auto' }}
                  />
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </>
  );
};

export default OphirItineraty2;
